import React from 'react';
import './Terms.scss';

const TermsAndConditions = () => {
  return (
    <div className="terms-page">
      <div className="container">
        <h1>Terms and Conditions</h1>
        <p>
          Welcome to Divya Jyotisa! By using our website (
          <a href="https://asthaddestiny.com/" target="_blank" rel="noopener noreferrer">
            https://asthaddestiny.com/
          </a>
          ) and engaging with our services, you agree to comply with and be bound by the following Terms and Conditions.
          Please review them carefully before using our site or purchasing any products or services.
        </p>

        <h2>Acceptance of Terms</h2>
        <p>
          By accessing or using this website, you agree to be bound by these Terms and Conditions and our Privacy Policy.
          If you do not agree to these terms, please refrain from using the website.
        </p>

        <h2>Services Offered</h2>
        <p>
          Divya Jyotisa offers various spiritual consultations, products, and courses, including but not limited to
          astrological readings, tarot consultations, healing gemstones, spiritual oils, and workshops. These services are
          for personal, spiritual growth and guidance. We do not guarantee specific outcomes from our consultations or
          products as results may vary for each individual.
        </p>

        <h2>Eligibility</h2>
        <p>
          You must be at least 18 years old or have parental/guardian consent to use our services and purchase our
          products. By accessing our site, you confirm that you meet this age requirement.
        </p>

        <h2>Payments and Pricing</h2>
        <p>
          All payments for services and products must be made in full at the time of booking or purchase. We reserve the
          right to adjust pricing at any time without prior notice. However, confirmed bookings or purchases made before
          such changes will not be affected.
        </p>

        <h2>Refund Policy</h2>
        <p>
          Our refund policy is detailed separately on our site and applies to all products and services. Please refer to
          the Refund Policy page for more information on eligibility for refunds.
        </p>

        <h2>Intellectual Property</h2>
        <p>
          All content on this website, including text, images, logos, designs, and other intellectual property, is the
          sole property of Divya Jyotisa, unless otherwise stated. You may not reproduce, distribute, or create derivative
          works from any material on this website without express written permission.
        </p>

        <h2>Personal Information</h2>
        <p>
          Your use of this website may involve providing personal information. By using our services, you agree to provide
          accurate, up-to-date information. We are committed to protecting your privacy, and our Privacy Policy outlines
          how we collect, use, and protect your information.
        </p>

        <h2>Disclaimers</h2>
        <ul>
          <li>
            <strong>No Professional Advice:</strong> The services and products offered on this site are for personal and
            spiritual development purposes only. They should not be considered professional advice (legal, financial,
            medical, etc.) and are not a substitute for professional services.
          </li>
          <li>
            <strong>No Guarantees:</strong> Astrological predictions, spiritual readings, and the effects of healing
            products are subject to personal interpretation. Results may vary from individual to individual, and we do not
            guarantee specific outcomes.
          </li>
        </ul>

        <h2>Limitation of Liability</h2>
        <p>
          Divya Jyotisa shall not be liable for any direct, indirect, incidental, or consequential damages arising from
          the use of our site, services, or products. This includes but is not limited to any damages caused by reliance
          on spiritual advice, loss of data, or disruptions in access to our site.
        </p>

        <h2>Third-Party Links</h2>
        <p>
          Our website may contain links to third-party websites or services. These links are provided for your
          convenience, and we do not endorse or take responsibility for the content or policies of such third parties.
          Accessing these links is at your own risk.
        </p>

        <h2>Changes to Terms</h2>
        <p>
          Divya Jyotisa reserves the right to modify these Terms and Conditions at any time without prior notice. Any
          changes will be effective immediately upon posting. By continuing to use the website after changes are made, you
          accept the revised Terms.
        </p>

        <h2>Governing Law</h2>
        <p>
          These Terms and Conditions are governed by and construed in accordance with the laws of India, without regard to
          its conflict of law provisions. Any disputes arising from these Terms will be subject to the exclusive
          jurisdiction of the courts of India.
        </p>

        <h2>Contact Information</h2>
        <p>
          For questions regarding these Terms and Conditions or any other matter, please contact us at:<br />
          <strong>Email:</strong> destinyastha@gmail.co
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
